import React, {ElementType} from 'react';
import {createRoot} from 'react-dom/client';
import {WidgetComponentType} from './types';
import {exposeWidget, init} from './utils';

function widgetEntryPoint(widgetId: string, Component: ElementType) {
  const el =
    document.getElementById(widgetId) ||
    document.getElementById('widget-placeholder');

  if (el) {
    const root = createRoot(el);

    const renderer: WidgetComponentType = {
      render: props => {
        root.render(<Component {...props} />);
      },
      unmount: root.unmount
    };

    exposeWidget(widgetId, renderer);
    init(widgetId);
  }
}

export default widgetEntryPoint;
